const ItemList = ({ linkTo, children }) => {
    return(
        <li className="breadcrumb-item"><a href={linkTo}>{children}</a></li>
    );
}

export default ItemList;